var map = {
	"./ejoyEnglish.svg": "170f",
	"./ejoyExtension.svg": "5948",
	"./ejoyGlot.svg": "aa0c",
	"./ejoyGo.svg": "a34b",
	"./ejoyLogo.svg": "84d9",
	"./ejoy_logo.svg": "16a9",
	"./glotLogo.svg": "6b5f",
	"./glot_epic.svg": "e4db",
	"./googleIcon.svg": "9fdc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5acb";